import { $CommercePlatform } from "./main";

window.sps.Utils = window['sps']['Util'] || {};
$CommercePlatform.init();
